export const SystemPalePalette: any = {
    0: '#FFFFFF',
    1: '#C2C4C5',
    2: '#FFADA8',
    3: '#FADF8D',
    4: '#AAE4B9',
    5: '#98bdfa',
}

export const SystemPaleBorderPalette: any = {
    0: '#FFFFFF',
    1: '#B4B7BB',
    2: '#F09C97',
    3: '#F2D681',
    4: '#9DDAAC',
    5: '#71a9fb',
}